<script setup lang="ts">
import type { IssueDetailDto } from '@/composables/useIssue';
import { SOURCE_LABEL } from './issue-enums';

interface Props {
  issue: IssueDetailDto;
}
defineProps<Props>();
</script>

<template>
  <div class="bg-surface border border-border rounded-lg p-4" data-testid="original-sources">
    <h3 class="text-caption font-semibold text-fg uppercase tracking-wide mb-3">Original Source</h3>
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 rounded-full bg-canvas-soft border border-border flex items-center justify-center">
        <svg class="w-4 h-4 text-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path
            stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
          />
        </svg>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-caption font-medium text-fg">{{ SOURCE_LABEL[issue.source] ?? String(issue.source) }}</p>
        <p class="text-caption text-muted mt-0.5">
          Submitted by <span class="text-fg">{{ issue.reporterDisplay }}</span>
        </p>
        <p v-if="issue.summary" class="text-body text-fg mt-1">{{ issue.summary }}</p>
      </div>
    </div>
  </div>
</template>
